import { Box, IconButton, styled, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const MonoText = styled(Typography)({
    fontFamily: 'monospace',
    whiteSpace: 'nowrap',
    userSelect: 'all'
});

const StyledContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    border: '1px solid',
    borderColor: theme.palette.divider,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden'
}));

const TextContainer = styled(Box)(({ theme }) => ({
    overflowX: 'scroll',
    flexGrow: 1,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
        display: 'none'
    }
}));

const IconButtonContainer = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    height: '100%'
}));

interface CopyLinkProps {
    link: string;
    onCopy: () => void;
    disabled?: boolean;
}
export const CopyLink = ({ link, onCopy, disabled }: CopyLinkProps) => (
    <StyledContainer>
        <TextContainer>
            <MonoText variant="body2">{link}</MonoText>
        </TextContainer>
        <IconButtonContainer>
            <IconButton
                onClick={onCopy}
                disabled={disabled}
                sx={{ height: '100%', borderRadius: 0, px: 1, py: 1.5 }}
            >
                <ContentCopyIcon sx={{ fontSize: '1rem' }} />
            </IconButton>
        </IconButtonContainer>
    </StyledContainer>
);
